import * as S from "@/components/Dashboard/styled";
import { StyledLinkTitle, StyledTitle } from "@/components/Dashboard/styled";
import { CONTENT_WIDTH } from "@/enums";
import { Card, Col, Spin, Table } from "antd";
import { arrayOf, bool, func, number, object, string } from "prop-types";

const NONE = 0;

const DashboardTablePreview = ({
  data,
  isLoading,
  isFetching,
  title,
  titleRoute,
  totalCount,
  columns,
  rowKey,
  expandable,
}) => (
  <Col xl={CONTENT_WIDTH.half} md={CONTENT_WIDTH.max}>
    <Card
      className="limitable h-full"
      title={
        <>
          <S.CardStatistic level={2}>
            {isLoading ? <Spin /> : data && (totalCount || NONE)}
          </S.CardStatistic>
          {titleRoute ? (
            <StyledLinkTitle to={titleRoute}>{title}</StyledLinkTitle>
          ) : (
            <StyledTitle>{title}</StyledTitle>
          )}
        </>
      }
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey={rowKey || (({ id }) => id)}
        loading={isLoading ?? isFetching}
        pagination={false}
        scroll={{ x: true }}
        expandable={expandable}
      />
    </Card>
  </Col>
);

DashboardTablePreview.propTypes = {
  data: arrayOf(object),
  isLoading: bool,
  isFetching: bool,
  title: string.isRequired,
  titleRoute: string,
  totalCount: number,
  columns: arrayOf(object).isRequired,
  rowKey: func,
  expandable: object,
};

export default DashboardTablePreview;
